import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2faa603a")

_pushScopeId("data-v-2faa603a")
const _hoisted_1 = { class: "passenger-info-box" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("成人")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("儿童")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 航空综合险 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "high-light" }, "￥ 30/单航段/份 ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" （含高额航意、延误取消保障等）")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保险条款")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("无忧退票险 ")
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "high-light" }, "￥ 30/单航段/份 ", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" （退票补偿票价损失的65%，最高1500元）")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("保险条款")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.number), 1),
    _createVNode(_component_el_form, {
      model: _ctx.information,
      rules: _ctx.rules,
      "label-position": "left",
      "label-width": "80px",
      ref: "form"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: "姓名",
          prop: "name"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.information.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.information.name = $event)),
              type: "text",
              name: "name"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "身份证号",
          prop: "ID"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.information.ID,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.information.ID = $event)),
              type: "text",
              name: "ID"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "身份" }, {
          default: _withId(() => [
            _createVNode(_component_el_radio, {
              modelValue: _ctx.information.identity,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.information.identity = $event)),
              label: "adult",
              onClick: _ctx.check1
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue", "onClick"]),
            _createVNode(_component_el_radio, {
              modelValue: _ctx.information.identity,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.information.identity = $event)),
              label: "child",
              onClick: _ctx.check2
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "保险信息",
          prop: "insurance"
        }, {
          default: _withId(() => [
            _createVNode("input", {
              type: "checkbox",
              name: "choose",
              value: "choose",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.insurance1 && _ctx.insurance1(...args)))
            }),
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_router_link, {
              to: "/guide/insurance_plane",
              target: "_blank"
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9,
            _createVNode("input", {
              type: "checkbox",
              name: "choose",
              value: "choose",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.insurance2 && _ctx.insurance2(...args)))
            }),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _createVNode(_component_router_link, {
              to: "/guide/insurance_ticket",
              target: "_blank"
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})